import { render, staticRenderFns } from "./simDatas.vue?vue&type=template&id=1ef08b0a&scoped=true&"
import script from "./simDatas.vue?vue&type=script&lang=js&"
export * from "./simDatas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef08b0a",
  null
  
)

export default component.exports